<template>
    <div class="m-cont">
        <div class="header-section">
            <div class="title-row">
                <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
                <h1 class="page-title">CARICA PRODOTTI</h1>
            </div>
        </div>

        <!-- Mobile-friendly Upload Section -->
        <div class="upload-section">
            <div class="upload-controls">
                <input 
                    type="file" 
                    ref="fileInput" 
                    @change="handleFileUpload" 
                    accept=".pdf,image/*" 
                    style="display: none" 
                />
                <input 
                    type="file" 
                    ref="cameraInput" 
                    @change="handleFileUpload" 
                    accept="image/*" 
                    capture="environment" 
                    style="display: none" 
                />

                <div class="mobile-upload-grid">
                    <div class="upload-card camera" @click="$refs.cameraInput.click()">
                        <div class="card-icon">📸</div>
                        <div class="card-text">Scatta Foto</div>
                    </div>
                    <div class="upload-card gallery" @click="$refs.fileInput.click()">
                        <div class="card-icon">📁</div>
                        <div class="card-text">Gallery / PDF</div>
                    </div>
                </div>

                <div v-if="parsingInvoiceId" class="status-info">
                    <span class="status-badge status-pending">In attesa di parsing LLM...</span>
                </div>
            </div>

            <!-- Loading Overlay -->
            <div v-if="uploading" class="upload-overlay">
                <div class="spinner-container">
                    <div class="custom-spinner"></div>
                    <p>Caricamento in corso...</p>
                </div>
            </div>
        </div>

        <!-- Products table from the "ordinato" pool -->
        <div class="tab-cont">
            <div class="table-responsive-wrapper">
                <table class="table">
                    <thead class="thead-dark">
                        <tr>
                            <th>Prodotto</th>
                            <th>Quantità (gr)</th>
                            <th>Prezzo (€/100g)</th>
                            <th>Totale</th>
                            <th>Azione</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(prodotto, i) in prodotti" :key="prodotto.code">
                            <td><span class="prodotto-nome">{{ prodotto.descrizio }}</span></td>
                            <td><input type="number" min="0" v-model="prodotto.quantitaordine"  class="form-control-input" /></td>
                            <td><input type="number" min="0" v-model="prodotto.prezzo" @input="()=> updatePrezzo(prodotto.code,prodotto.prezzo)" class="form-control-input" /></td>
                            <td class="total-cell">{{ (prodotto.prezzo / 100 * prodotto.quantitaordine).toFixed(2) }}€</td>
                            <td><button class="btn btn-success btn-sm" @click="()=>carica(prodotto.code,prodotto.quantitaordine,prodotto.prezzo,i)">Carica</button></td>
                        </tr>
                        <tr v-if="prodotti.length === 0">
                            <td colspan="5" class="no-data">Nessun prodotto ordinato da caricare.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Reconciliation Modal -->
        <div v-if="showModal" class="modal-overlay">
            <div class="modal-content">
                <div class="modal-header">
                    <h4>Riconciliazione Fattura</h4>
                    <button @click="showModal = false" class="close-btn">&times;</button>
                </div>
                <div class="modal-body">
                    <!-- Preview Section -->
                    <div class="invoice-preview">
                        <h5>Anteprima</h5>
                        <div class="file-container" v-if="currentFattura">
                            <img :src="getInvoiceUrl(currentFattura.file_path)" alt="Fattura" v-if="isImage(currentFattura.file_path)" />
                            <iframe :src="getInvoiceUrl(currentFattura.file_path)" width="100%" height="400px" v-else></iframe>
                        </div>
                    </div>

                    <!-- Extraction Section -->
                    <div class="extracted-list">
                        <h5>Prodotti Rilevati</h5>
                        <div class="table-scroll">
                            <table class="reconcile-table">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Q.tà</th>
                                        <th>Prezzo</th>
                                        <th>Mappa a...</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(prod, idx) in extractedProducts" :key="idx">
                                        <td><input type="text" v-model="prod.nome" /></td>
                                        <td><input type="number" v-model="prod.quantita" /></td>
                                        <td><input type="number" step="0.01" v-model="prod.prezzo" /></td>
                                        <td>
                                            <select v-model="prod.matchedCode">
                                                <option :value="null">Non associare</option>
                                                <option v-for="p in tuttiProdottiMappati" :key="p.code" :value="p.code">
                                                    {{ p.descrizio }}
                                                </option>
                                            </select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" @click="showModal = false">Annulla</button>
                    <button class="btn btn-primary" @click="confirmReconciliation" :disabled="!isReadyToConfirm">Conferma Carico</button>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import moment from 'moment'
import { store } from '../store/store.js'

export default {
  name: 'CaricaProdotti',
  data: function () {
    return {
        prodotti:[],
        tuttiProdottiMappati: [], 
        store,
        selectedFile: null,
        uploading: false,
        parsingInvoiceId: null,
        pollingInterval: null,
        showModal: false,
        extractedProducts: [],
        currentFattura: null
    }
   },
  computed: {
    isReadyToConfirm() {
        return this.extractedProducts.some(p => p.matchedCode);
    }
  },
  methods: {
    home() {
        this.$router.push({ name: "Gestionale"})
    },
    displayProduct() {
        this.axios.post(this.store.path+'displayProduct',{headers:{
            authorization: `Bearer  ${JSON.parse(localStorage.token)}`
        }}).then((response) => {
            if(response.data.messaggio){
                this.prodotti = [];
                this.tuttiProdottiMappati = response.data.messaggio;
                response.data.messaggio.forEach(element => {
                      element.prezzo = element.prezzo ? element.prezzo : 0;
                      element.quantitaordine = element.quantitaordine ? element.quantitaordine : 0;
                      if(element.stato == "ordinato"){
                          this.prodotti.push(element);
                      }
                });
            }
        })
    },
    carica(code, quantitaordine, prezzo, i) {
        prezzo = prezzo / 100 * quantitaordine;
        this.axios.post(this.store.path+'carica',{
            code: code,
            prezzo: prezzo,
            quantitaordine: quantitaordine,
            tm: moment(new Date()).unix(),
            headers: { authorization: `Bearer  ${JSON.parse(localStorage.token)}` }
        }).then((response) => {
            if(response.data.messaggio){
                this.prodotti.splice(i, 1)
                console.log('Prodotto caricato con successo')
            }
        })
    },
    updatePrezzo(code, prezzo) {
        this.axios.post(this.store.path+'updatePrezzo',{
            code: code,
            prezzo: prezzo,
            headers: { authorization: `Bearer  ${JSON.parse(localStorage.token)}` }
        })
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.uploadInvoice();
      }
    },
    async uploadInvoice() {
      if (!this.selectedFile) return;

      this.uploading = true;
      const formData = new FormData();
      formData.append('file', this.selectedFile);

      try {
        const response = await this.axios.post(this.store.path + 'fattura/upload', formData, {
          headers: {
            authorization: `Bearer ${JSON.parse(localStorage.token)}`
          }
        });
        this.parsingInvoiceId = response.data.fatturaId;
        this.startPolling();
      } catch (error) {
        console.error('Upload error:', error);
        let errorMsg = 'Errore durante il caricamento della fattura.';
        if (error.response) {
            // El servidor respondió con un código de error
            errorMsg += ` (Status: ${error.response.status})`;
            if (error.response.status === 413) {
                errorMsg += '\nIl file è troppo grande per il server (Nginx limit).';
            }
        } else if (error.request) {
            // La petición fue fatta ma non c'è stata risposta (es. CORS o server down)
            errorMsg += '\nNessuna risposta dal server (possibile errore di rete o CORS).';
        }
        alert(errorMsg);
      } finally {
        this.uploading = false;
        this.selectedFile = null;
      }
    },
    startPolling() {
        if (this.pollingInterval) return;
        this.pollingInterval = setInterval(async () => {
            await this.checkInvoiceStatus();
        }, 3000);
    },
    async checkInvoiceStatus() {
        try {
            const response = await this.axios.get(this.store.path + 'fattura', {
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            });
            const invoice = response.data.find(i => i._id === this.parsingInvoiceId);
            if (invoice && invoice.stato === 'PROCESSED') {
                this.stopPolling();
                this.openReconciliation(invoice);
            } else if (invoice && invoice.stato === 'ERROR') {
                this.stopPolling();
                alert(`Errore durante il parsing AI della fattura (ID: ${this.parsingInvoiceId}). Controlla i log del server Python.`);
            }
        } catch (error) {
            console.error('Polling error:', error);
        }
    },
    stopPolling() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
        this.parsingInvoiceId = null;
    },
    openReconciliation(invoice) {
        this.currentFattura = invoice;
        this.extractedProducts = invoice.prodotti.map(p => {
            const match = this.tuttiProdottiMappati.find(mp => mp.descrizio.toLowerCase() === p.nome.toLowerCase());
            return {
                ...p,
                matchedCode: match ? match.code : null
            };
        });
        this.showModal = true;
    },
    async confirmReconciliation() {
        const payload = {
            fatturaId: this.currentFattura._id,
            products: this.extractedProducts
                .filter(p => p.matchedCode)
                .map(p => ({
                    code: p.matchedCode,
                    quantita: p.quantita,
                    prezzo: p.prezzo,
                    nome: p.nome
                }))
        };

        try {
            await this.axios.post(this.store.path + 'fattura/confirm-load', payload, {
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            });
            alert('Prodotti caricati con successo!');
            this.showModal = false;
            this.displayProduct();
        } catch (error) {
            console.error('Confirm error:', error);
            alert('Errore durante il caricamento riconciliato.');
        }
    },
    getInvoiceUrl(filePath) {
        if (!filePath) return '';
        const filename = filePath.split('/').pop();
        let baseUrl = this.store.path.replace('/login/', '/').replace('/login', '/');
        if (!baseUrl.endsWith('/')) baseUrl += '/';
        return `${baseUrl}uploads/${filename}`;
    },
    isImage(filePath) {
        if (!filePath) return false;
        const ext = filePath.split('.').pop().toLowerCase();
        return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);
    }
  },
  beforeMount() {
      this.displayProduct();
  },
  beforeUnmount() {
      this.stopPolling();
  }
}
</script>

<style scoped>
.m-cont {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #f8f9fa;
}

.header-section {
    padding: 20px;
    background: white;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.title-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
}

.page-title {
    margin: 0;
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
}

/* Base Upload Section Styles */
.upload-section {
    padding: 20px;
}

.mobile-upload-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    max-width: 600px;
    margin: 0 auto;
}

.upload-card {
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.05);
    cursor: pointer;
    transition: transform 0.2s;
    text-align: center;
}

.upload-card:active {
    transform: scale(0.95);
}

.card-icon {
    font-size: 2rem;
    margin-bottom: 10px;
}

.card-text {
    font-weight: bold;
    color: #333;
}

.status-info {
    margin-top: 15px;
    text-align: center;
}

.status-badge {
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 0.9rem;
    font-weight: bold;
}

.status-pending {
    background: #fff3cd;
    color: #856404;
    border: 1px solid #ffeeba;
}

/* Spinner & Overlay */
.upload-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
}

.spinner-container {
  text-align: center;
}

.custom-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #28a745;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Products Table */
.tab-cont {
    padding: 20px;
    flex-grow: 1;
}

.table-responsive-wrapper {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    overflow: hidden;
}

.table {
    width: 100%;
    border-collapse: collapse;
}

.thead-dark th {
    background-color: #343a40;
    color: white;
    padding: 12px;
    text-align: left;
}

td {
    padding: 12px;
    border-bottom: 1px solid #eee;
    text-align: left;
}

.form-control-input {
    width: 80px;
    padding: 6px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

.total-cell {
    font-weight: bold;
    color: #28a745;
}

.no-data {
    text-align: center;
    padding: 40px;
    color: #666;
}

/* Reconciliation Modal */
.modal-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

.modal-content {
    background: white;
    width: 95%;
    max-width: 1200px;
    max-height: 90vh;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.modal-header {
    background: #28a745;
    color: white;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
}

.modal-body {
    padding: 20px;
    display: grid;
    grid-template-columns: 1fr 1.5fr;
    gap: 20px;
    overflow-y: auto;
}

.invoice-preview, .extracted-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.file-container {
    border: 1px solid #eee;
    background: #f8f9fa;
    border-radius: 8px;
    overflow: hidden;
}

.file-container img {
    width: 100%;
    height: auto;
}

.table-scroll {
    max-height: 400px;
    overflow-y: auto;
    border: 1px solid #eee;
}

.reconcile-table {
    width: 100%;
    border-collapse: collapse;
}

.reconcile-table th, .reconcile-table td {
    padding: 8px;
    border: 1px solid #eee;
    font-size: 0.9rem;
}

.reconcile-table input, .reconcile-table select {
    width: 100%;
    padding: 4px;
    box-sizing: border-box;
}

.modal-footer {
    padding: 15px 20px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

@media (max-width: 800px) {
    .modal-body {
        grid-template-columns: 1fr;
    }
    .mobile-upload-grid {
        grid-template-columns: 1fr;
    }
}
</style>